import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import { AlertTriangle } from 'lucide-react';

export default function AdminErrors() {
  const { t, i18n } = useTranslation();
  const { data, isLoading } = useQuery({
    queryKey: ['/admin/client-errors'],
    refetchInterval: 60_000,
  });
  const rows = data?.data ?? [];

  return (
    <div className="p-6 max-w-6xl mx-auto animate-fade-in">
      <div className="mb-4 flex items-center gap-2">
        <AlertTriangle size={18} className="text-destructive" />
        <h1 className="text-xl font-semibold text-foreground">{t('adm_errors.title')}</h1>
        <Badge variant="secondary">{rows.length}</Badge>
      </div>
      <p className="mb-4 text-sm text-muted-foreground">
        {t('adm_errors.subtitle')}
      </p>

      <div className="overflow-hidden rounded-xl border border-border bg-card">
        <table className="w-full">
          <thead>
            <tr className="border-b border-border bg-muted/50">
              <th className="p-3 text-left text-xs font-medium text-muted-foreground">{t('adm_errors.date')}</th>
              <th className="p-3 text-left text-xs font-medium text-muted-foreground">{t('adm_errors.page')}</th>
              <th className="p-3 text-left text-xs font-medium text-muted-foreground">{t('adm_errors.error')}</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr><td colSpan={3} className="p-8 text-center text-muted-foreground">{t('adm_common.loading')}</td></tr>
            ) : rows.length === 0 ? (
              <tr><td colSpan={3} className="p-8 text-center text-muted-foreground">{t('adm_errors.empty')}</td></tr>
            ) : (
              rows.map((r) => (
                <tr key={r.id} className="border-b border-border last:border-0 align-top hover:bg-muted/30">
                  <td className="whitespace-nowrap p-3 text-xs text-muted-foreground">
                    {new Date(r.created_at).toLocaleString(i18n.language)}
                  </td>
                  <td className="p-3 font-mono text-xs text-foreground">{r.route || '—'}</td>
                  <td className="p-3 text-sm text-foreground">
                    {r.message}
                    {r.stack && (
                      <details className="mt-1">
                        <summary className="cursor-pointer text-xs text-muted-foreground">{t('adm_errors.details')}</summary>
                        <pre className="mt-1 max-h-48 overflow-auto whitespace-pre-wrap rounded-lg bg-muted p-2 text-[11px] text-muted-foreground">
                          {r.stack}
                        </pre>
                      </details>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
